import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { ADDRESS_STORE, ADDRESS_HASH } from './store.js';
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Addresses
export const filterAddresses = async (parameters = {}) => {
    return PROXY.handleFilter(PEGASUS.filterAddresses, parameters)
        .then(addresses => PROXY.updateStoreBulk(ADDRESS_STORE, addresses));
};
// Fetch Address
export const fetchAddress = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchAddress, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(ADDRESS_STORE, null, data);
    });
};
// Create Address
export const createAddress = async (body) => {
    return PROXY.handleCreate(PEGASUS.createAddress, body)
        .then(response => PROXY.updateStore(ADDRESS_STORE, ADDRESS_HASH, response));
};
// Update Address
export const updateAddress = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateAddress, keys, body)
        .then(response => PROXY.updateStore(ADDRESS_STORE, ADDRESS_HASH, response));
};
// Delete Address
export const deleteAddress = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteAddress, keys)
        .then(response => PROXY.removeFromStore(ADDRESS_STORE, ADDRESS_HASH, keys.addressKey, response));
};
/* eslint-enable arrow-body-style */ 
